import React, { useEffect, useState } from 'react'
import NoticeBarContainer from 'APP/Components/NoticeBarContainer'
import { ResponsiveScrollView } from 'APP/Converse/Layout'
import SearchLocation from './SearchLocation'
import { Container, Disclaimer, Form } from './styles'
import SpecialtyPicker, { SpecialtyValue } from './SpecialtyPicker'
import { NativeStackScreenProps } from '@react-navigation/native-stack'
import { selectPlaces } from 'APP/Store/Places/selectors'
import { useDispatch, useSelector } from 'APP/Hooks/redux'
import SelfNavigationResults from './SelfNavigationResults'
import { selectPatientProfileLocationCoordinates } from 'APP/Redux/PatientRedux'
import { placesActions } from 'APP/Store/Places/slice'
import i18n from 'APP/I18n'
import { wrapScrollView } from 'APP/Converse/Inputs/AutocompleteInput'
import { Place } from './PlacePicker'
import sprigClient from 'APP/Services/Sprig'
import { View } from 'react-native'
import { useTheme } from 'styled-components/native'

// @ts-expect-error: ResponsiveScrollView is not properly typed.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ResponsiveScrollViewWithAutocomplete = wrapScrollView<any>(ResponsiveScrollView)

export type SelfNavigationScreenProps = NativeStackScreenProps<
  ReactNavigation.RootParamList,
  'selfNavigation'
>

function SelfNavigationScreen({ route }: SelfNavigationScreenProps) {
  const params = route.params
  const theme = useTheme()
  const [specialty, setSpecialty] = useState<SpecialtyValue>()
  const places = useSelector(selectPlaces)
  const dispatch = useDispatch()
  const coordinates = useSelector(selectPatientProfileLocationCoordinates)
  const [place, setPlace] = useState<Place | 'current' | null>(coordinates ? 'current' : null)
  const locale = i18n?.baseLocale ?? 'en'

  useEffect(() => {
    return () => {
      sprigClient.track(`SELF_NAV_CLOSED_${locale.toUpperCase()}`)
    }
  }, [locale])

  // If we get coords but no place is selected, update to 'current'.
  useEffect(() => {
    if (coordinates && place == null) {
      setPlace('current')
    }
  }, [coordinates, place])

  useEffect(() => {
    const origin = place === 'current' ? coordinates : place?.place_id
    if (origin && specialty) {
      dispatch(
        placesActions.getPlaces({
          query: specialty.q,
          origin,
          language_code: locale,
        })
      )
    }
  }, [coordinates, place, specialty, locale, dispatch])

  return (
    <View style={{ flex: 1, paddingBottom: theme.insets.bottom }}>
      <NoticeBarContainer>
        <ResponsiveScrollViewWithAutocomplete
          contentContainerStyle={{}}
          contentContainerInnerStyle={{}}
          footer={null}
        >
          <Container>
            <Disclaimer
              testID="selfNavigationDisclaimer"
              description={i18n.t('SelfNavigationScreen.disclaimer')}
              leftIcon={{ src: 'info-outline', variant: 'materialIcons', color: 'text' }}
            />
            <Form>
              <SpecialtyPicker
                initialSpecialtyKey={params?.specialtyKey}
                onValueChange={setSpecialty}
              />
              <SearchLocation place={place} onValueChange={setPlace} />
            </Form>
            {specialty && <SelfNavigationResults specialty={specialty.label} results={places} />}
          </Container>
        </ResponsiveScrollViewWithAutocomplete>
      </NoticeBarContainer>
    </View>
  )
}

export default SelfNavigationScreen
